import { render, staticRenderFns } from "./ToggleDNUFlag.vue?vue&type=template&id=13817edc&scoped=true"
import script from "./ToggleDNUFlag.vue?vue&type=script&lang=ts"
export * from "./ToggleDNUFlag.vue?vue&type=script&lang=ts"
import style0 from "./ToggleDNUFlag.vue?vue&type=style&index=0&id=13817edc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13817edc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13817edc')) {
      api.createRecord('13817edc', component.options)
    } else {
      api.reload('13817edc', component.options)
    }
    module.hot.accept("./ToggleDNUFlag.vue?vue&type=template&id=13817edc&scoped=true", function () {
      api.rerender('13817edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ToggleDNUFlag.vue"
export default component.exports